<template>
  <div class="checkbox" :class="value && 'active'" @click="handler">
    <div class="checkbox__input">
      <img class="checkbox__icon" src="/img/icon/tick.svg" alt="">
    </div>
    <div class="checkbox__label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'label'],
  methods: {
    handler() {
      this.$emit('input', !this.value);
    }
  },
};
</script>

<style lang="scss">
  .checkbox {
    display: flex;
    align-items: center;
    &.active {
      .checkbox__input {
        background-color: #fff;
      }
      .checkbox__icon {
        opacity: 1;
      }
    }
    &__input {
      width: 20px;
      min-width: 20px;
      height: 20px;
      border: 1px solid #9aa1af;
      border-radius: 2px;
      background-color: #e5e5e5;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: .3s;
    }
    &__icon {
      width: 16px;
      height: 12px;
      opacity: 0;
      transition: .3s;
    }
    &__label {
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-left: 8px;
    }
  }
</style>
